import { render, staticRenderFns } from "./explainPage.vue?vue&type=template&id=2cffc07d&"
import script from "./explainPage.vue?vue&type=script&lang=js&"
export * from "./explainPage.vue?vue&type=script&lang=js&"
import style0 from "./explainPage.vue?vue&type=style&index=0&id=2cffc07d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports